import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ScrollView,
    ActivityIndicator, RefreshControl
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import {DrawerNavigationProp} from "@react-navigation/drawer";
import ClientItem from "../Components/ClientItem";
import RNPickerSelect from 'react-native-picker-select';
import {AntDesign as Icon} from '@react-native-vector-icons/ant-design/static';
import CourierItem from "../Components/CourierItem";
import AlertModal from "../Components/AlertModal";
import ICourier from "../Models/Courier/ICourier";
import IClient from "../Models/Client/IClient";
import HttpRequest from "../utils/HttpRequest";
import AppButton from "../Components/AppButton";
import { saveCouriers } from '../Models/Courier/CourierActions';
import ISubClient from "../Models/Client/ISubClient";
import ConfirmionModal from "../Components/ConfirmionModal";

type navProps = DrawerNavigationProp< any, 'Clients'>;
interface IProps {
    navigation:navProps;
    saveCouriers:(couriers:ICourier[])=>AnyAction
}
interface IState {
    couriers:ICourier[];
    courierToAdd:ICourier
    isAddOpened:boolean;
    showAlert:boolean;
    alertText:string;
    isErrorAlert:boolean;
    loading:boolean;
    filterName:string;
    filterArea:string;
    filterLic:string;
    isSearching:boolean;
    fetching:boolean;
    courierToRemove?:ICourier
    showConfirm:boolean;
}

class Courier extends React.Component<IProps> {

    state:IState={
        couriers:[],
        isAddOpened:false,
        showAlert:false,
        isErrorAlert:false,
        alertText:'',
        loading:false,
        filterName:'',
        filterLic:'',
        filterArea:'',
        isSearching:false,
        courierToAdd:{name:'',licenseType:'',area:'',phone:'',isDeleted:false},
        fetching:false,
        showConfirm:false
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData(){
        this.setState({fetching:true})
        HttpRequest('couriers',"GET").then((result)=>{
            this.props.saveCouriers(result.data);
            this.setState({couriers:result.data})
        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    setCourierProp<K extends keyof ICourier>(value:any,key:K){
        let c=this.state.courierToAdd;
        c[key]=value;
        this.setState({courierToAdd:c})

    }
    addCourier(){
        let c=  this.state.courierToAdd;

        if(c.name=='' || c.area=='' || c.area=='איזור' || c.phone=='' || c.licenseType=='' || c.licenseType=='סוג רישיון'){
            this.setState({showAlert:true,alertText:'נא למלא את כל הטפס',isErrorAlert:true})
            return;
        }
        this.setState({loading:true})
        HttpRequest('couriers',"POST",{courier:c}).then((res)=>{
            this.setState({showAlert:true,alertText:'פעולה בוצעה בהצלחה',isErrorAlert:false})
            let c=res.data;
            let couriers=this.state.couriers;
            couriers.push(c);
            this.setState({couriers:couriers})
            //Alert.alert(JSON.stringify(res.data))
        }).catch(e=>{
            this.setState({showAlert:true,alertText:'שגיאת רשת,אנא נסה שוב',isErrorAlert:true})
        }).finally(()=>this.setState({loading:false}))
    }
    getData(){
        if(this.state.isSearching){
            if(this.state.filterName=='' && this.state.filterArea =='' && this.state.filterLic=='')
                return this.state.couriers;
            return this.state.couriers.filter(c=>{
                let isName=false;
                let isNameFiltered=false;
                let isArea=false;
                let isAreaFiltered=false;
                let isLen=false;
                let isLenFiltered=false;
                if(this.state.filterName!=''){
                    isName=true;
                    if( c.name.startsWith(this.state.filterName)){
                        isNameFiltered=true;
                    }

                }
                if(this.state.filterLic!=''){
                    isLen=true;
                    if(c.licenseType.startsWith(this.state.filterLic)){
                        isLenFiltered=true;
                    }
                }
                if(this.state.filterArea!='' ){
                    isArea=true;
                    if(c.area.startsWith(this.state.filterArea)){
                        isAreaFiltered=true;
                    }
                }
                return (isName ? isNameFiltered :true) && (isArea ? isAreaFiltered : true) && (isLen ? isLenFiltered : true)
            })

        }
        return this.state.couriers;
    }
    removeCourier(){
        this.setState({showConfirm:false})
        let couriers=this.state.couriers;
        let courierToRemove=this.state.courierToRemove;
        if(!courierToRemove) return;
        couriers=couriers.filter(c=>c.id!=this.state.courierToRemove?.id)
        this.setState({couriers:couriers})
        HttpRequest('couriers',"DELETE",{id:courierToRemove.id}).then((result)=>{

        }).catch(e=>{
            console.log(e)
        })
    }
    render() {
       const data:any[]=[
           {name:'מוהנד עבד אלהדי',area:'צפון',phone:'052-1234567',licenseType:'B'}
       ]
        return(
            <ScrollView keyboardShouldPersistTaps="handled" refreshControl={<RefreshControl refreshing={this.state.fetching} onRefresh={()=>this.getData()} />} style={{display:'flex',flexDirection:'column',backgroundColor:'white',flex:1,width:'100%'}}>
                <TouchableOpacity style={{height:35,width:'100%',flexDirection:'row',backgroundColor:'#F6F6F6',alignItems:'center',paddingLeft:15}} onPress={()=>this.setState({isAddOpened:!this.state.isAddOpened})} >
                    <View style={{backgroundColor:'#019FB2',width:25,height:25,borderRadius:25,justifyContent:'center',alignItems:'center'}}>
                        <AppText style={{color:'#fff',fontSize:22,lineHeight:30,fontWeight:"700"}}>{this.state.isAddOpened?"-":"+"}</AppText>
                    </View>
                    <AppText style={{color:'#3A3A3A',fontSize:18,lineHeight:30,marginLeft:10,fontWeight:'500'}}>הוספת שליח</AppText>
                </TouchableOpacity>
                <HideableView hidden={!this.state.isAddOpened} style={{width:'100%',backgroundColor:'#F6F6F6',alignItems:'center'}}>
                    <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setCourierProp(text,"name")} style={{height:30,paddingTop:1,paddingBottom:1,width:'50%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'שם'}/>
                    <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setCourierProp(text,"phone")} style={{height:30,paddingTop:1,paddingBottom:1,width:'50%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'טלפון'}/>

                    <View style={{width:'50%',height:30,backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginTop:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                        <View style={{flex:0.8,justifyContent:'center'}}>
                            <RNPickerSelect
                                onValueChange={(value) => this.setCourierProp(value,"area")}
                                placeholder={{ label: 'איזור', value: 'איזור' }}
                                style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                items={[
                                    { label: 'צפון', value: 'צפון' },
                                    { label: 'חיפה', value: 'חיפה' },
                                    { label: 'קריות', value: 'קריות' },
                                    { label: 'מרכז', value: 'מרכז' },
                                    { label: 'דרום', value: 'דרום' },
                                ]}
                            />
                        </View>
                        <View style={{flex:0.2,justifyContent:'center'}}>
                            <Icon name="down" size={15} color="#000" />
                        </View>

                    </View>
                    <View style={{width:'50%',height:30,backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginTop:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                        <View style={{flex:0.8,justifyContent:'center'}}>
                            <RNPickerSelect
                                onValueChange={(value) => this.setCourierProp(value,"licenseType")}
                                placeholder={{ label: 'סוג רישיון', value: 'סוג רישיון' }}
                                style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                items={[
                                    { label: 'A', value: 'A' },
                                    { label: 'A1', value: 'A1' },
                                    { label: 'B', value: 'B' },
                                    { label: 'C', value: 'C' },
                                ]}
                            />
                        </View>
                        <View style={{flex:0.2,justifyContent:'center'}}>
                            <Icon name="down" size={15} color="#000" />
                        </View>

                    </View>
                    <View style={{flexDirection:'row',justifyContent:'center',marginTop:10,marginBottom:10}}>
                        <AppButton text={'הוסף'} onPress={()=>this.addCourier()} width={70} height={30} isLoading={this.state.loading}/>
                    </View>

                </HideableView>
                <View style={{height:35,width:'100%',flexDirection:'row',backgroundColor:'white',alignItems:'center',paddingLeft:10}}>
                    <AppText style={{color:'#3A3A3A',fontSize:18,lineHeight:30,marginLeft:0,fontWeight:'500'}}> סנן</AppText>
                    <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setState({filterName:text})} style={{height:25,paddingTop:1,paddingBottom:1,width:'28%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'שם'}/>
                    <View style={{width:'19%',height:25,backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                        <View style={{flex:0.8,justifyContent:'center'}}>
                            <RNPickerSelect
                                onValueChange={(value) => this.setState({filterArea:value})}
                                placeholder={{ label: 'איזור', value: 'איזור' }}
                                style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                items={[
                                    { label: 'צפון', value: 'צפון' },
                                    { label: 'חיפה', value: 'חיפה' },
                                    { label: 'קריות', value: 'קריות' },
                                    { label: 'מרכז', value: 'מרכז' },
                                    { label: 'דרום', value: 'דרום' },
                                ]}
                            />
                        </View>
                        <View style={{flex:0.2,justifyContent:'center'}}>
                            <Icon name="down" size={10} color="#000" />
                        </View>

                    </View>
                    <View style={{width:'19%',height:25,backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                        <View style={{flex:0.8,justifyContent:'center'}}>
                            <RNPickerSelect
                                onValueChange={(value) => this.setState({filterLic:value})}
                                placeholder={{ label: 'רישיון', value: 'רישיון' }}
                                style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                items={[
                                    { label: 'A', value: 'A' },
                                    { label: 'A1', value: 'A1' },
                                    { label: 'B', value: 'B' },
                                    { label: 'C', value: 'C' },
                                ]}
                            />
                        </View>
                        <View style={{flex:0.2,justifyContent:'center'}}>
                            <Icon name="down" size={10} color="#000" />
                        </View>

                    </View>
                    <TouchableOpacity onPress={()=>this.setState({isSearching:!this.state.isSearching})} style={{width:55,height:22,backgroundColor:'#019FB2',marginLeft:10,justifyContent:'center',alignItems:'center',borderRadius:25}}>
                        <AppText style={{color:'#fff',fontWeight:'700'}}>{this.state.isSearching?'ביטול':'חיפוש'}</AppText>
                    </TouchableOpacity>

                </View>
                <FlatList
                    data={this.getData()}
                    ListHeaderComponent={()=><View style={{height:30,width:'100%',backgroundColor:'#373737',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                        <View style={{flex:0.28,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>שם</AppText>
                        </View>
                        <View style={{flex:0.18,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>איזור</AppText>
                        </View>
                        <View style={{flex:0.24,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>טלפון</AppText>
                        </View>
                        <View style={{flex:0.18,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>רישיון</AppText>
                        </View>
                        <View style={{flex:0.13,alignItems:'flex-start'}}>

                        </View>
                    </View>}
                    renderItem={({ item }) =><CourierItem courier={item} removeCallBack={(c:ICourier)=>this.setState({showConfirm:true,courierToRemove:c})}/> }
                />
                <AlertModal isError={this.state.isErrorAlert} show={this.state.showAlert} text={this.state.alertText} closeCallBack={()=>this.setState({showAlert:false})}/>
                   <ConfirmionModal confirmCallBack={()=>this.removeCourier()} closeCallBack={()=>this.setState({showConfirm:false})} text={'האם רציתה למחוק'+" "+this.state.courierToRemove?.name+" ?"} show={this.state.showConfirm}/>

            </ScrollView>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {

    };
};

const mapDispatchToProps ={
    saveCouriers:saveCouriers
};

export default connect(mapStateToProps, mapDispatchToProps)(Courier);
